// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-dialog-content {
  width: 100%;
  padding: 2px 24px !important;
  background-color: #f0f0f0;
  overflow: hidden !important;
  max-height: unset !important;
}

.content {
  padding: 10px;
  border-radius: 4px;
  overflow: hidden;
}

mat-dialog-actions {
  background-color: #f0f0f0;
  padding: 8px 24px !important;
  justify-content: flex-end !important;
  min-height: unset !important;
}

.button-gap {
  gap: 12px;
}

.btn::after {
  content: '' !important;
  display: none !important;
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/tools/manage-materials/add-material-dialog/add-material-dialog.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B","sourcesContent":["mat-dialog-content {\n  width: 100%;\n  padding: 2px 24px !important;\n  background-color: #f0f0f0;\n  overflow: hidden !important;\n  max-height: unset !important;\n}\n\n.content {\n  padding: 10px;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\nmat-dialog-actions {\n  background-color: #f0f0f0;\n  padding: 8px 24px !important;\n  justify-content: flex-end !important;\n  min-height: unset !important;\n}\n\n.button-gap {\n  gap: 12px;\n}\n\n.btn::after {\n  content: '' !important;\n  display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
